import { Column } from "@/components/Column";
import { Text } from "@/components/Text";
import { SadieBreakdownRow } from "@/components/tools/sadie-dashboard/SadieBreakdownRow";
import { SadieStatDelta } from "@/components/tools/sadie-dashboard/SadieStatDelta";
import { Card } from "@ui/card";

import { sadieDashboard } from "@/lib/sadieDashboard";
import {
  SadieDashboardExternalApplications,
  SadieDashboardRange,
  SadieStatFormat,
} from "@/types";

// Applications Sadie ran on employers' own ATSs. Each row is counted by when
// that step happened, so the rows don't have to add up like a funnel.
export const SadieExternalApplicationsCard = ({
  externalApplications,
  range,
}: {
  externalApplications: SadieDashboardExternalApplications;
  range: SadieDashboardRange;
}) => (
  <Card className="p-5">
    <Column className="gap-3">
      <Column className="gap-0.5">
        <Text className="font-plex-mono text-[9px] font-medium uppercase tracking-wider text-slate-500">
          Applications
        </Text>
        <Text className="text-sm font-semibold text-slate-900">
          External applications
        </Text>
      </Column>
      <Column className="gap-0.5">
        <Text className="text-3xl font-semibold text-slate-900">
          {sadieDashboard.formatValue(
            externalApplications.submitted,
            SadieStatFormat.COUNT,
          )}
        </Text>
        <Text className="text-xs font-normal text-slate-500">
          submitted and confirmed by the employer
        </Text>
      </Column>
      <SadieStatDelta
        format={SadieStatFormat.COUNT}
        range={range}
        stat={externalApplications.submitted}
      />
      <Column className="gap-1.5 border-t border-slate-100 pt-3">
        <SadieBreakdownRow
          count={externalApplications.started.value}
          label="Started"
        />
        <SadieBreakdownRow
          count={externalApplications.saidYes.value}
          label="Said yes"
        />
        <SadieBreakdownRow
          count={externalApplications.submitted.value}
          label="Submitted"
        />
      </Column>
    </Column>
  </Card>
);
